<template>
    <div>
        <CompassMenu trigger="click" placement="left-start" customClass="doc-overview-context-menu">
            <CompassIconButton icon="action" />
            <template #dropdown>
                <CompassDropdownOption
                    :label="$t.__('common.actions.edit')"
                    @itemSelected="$emit('update')"
                />
                <CompassDropdownOption
                    :label="$t.__('common.actions.unlink')"
                    @itemSelected="$emit('unlink')"
                />
            </template>
        </CompassMenu>
    </div>
</template>

<script>
export default {
    name: 'ContextMenu',
    emits: ['update', 'unlink'],
};
</script>

<style>
#compass-menu-container .doc-overview-context-menu {
    width: 200px !important;
    z-index: 4 !important;
}

.doc-overview-context-menu .compass-icon {
    cursor: pointer;
}
</style>
